import React, { Component, useDebugValue } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Label,
  Input,
  Button,
  Row,
  CustomInput,
  Popover,
  PopoverHeader,
  PopoverBody,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import Tooltip from "../../../../components/UI/TooltipIcon/TooptipIcon";
// import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import Loading from "../../../../hoc/Loading/Loading";
import axios from "../../../../axios";
import * as actionCreators from "../../../../modules/actions/index";
import * as url from "../../../../utils/url";
// import Dropdown from '../../Reusable/Dropdown'
import DatePicker from "react-datepicker";
import { privacyLabel, checkUserPrivileges } from "../../../../utils/constants";
import { deepClone } from "./../../../../utils/copyObject";

class EditDboard extends Component {
  foundUsersArray = React.createRef();
  userTableContainer = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      title: "",
      privacy: null,
      permission: null,
      displayUsers: [],
      dashboardOwner: this.props.dashboardOwner,
      isUserList: false,
      invitedUsers: [],
      newUsersInvited: [],
      permissionsChanged: [],
      customUser: "",
      newUserAdded: null,
      dropdownOpen: false,
      dropdownFilter: false,
      currentDashboard: { ...this.props.currentDashboard },
      errMsg: "",
      preventCreate: false,
      isResourceSelect: null,

      error: false,
      activeFilterMenu: "",
      errorMessage: "",
      isPrivacy: this.props.isPrivacy,

      isCreateDashboard: this.props.isCreateDashboard,

      privacyPopoverOpen: false,
      permissionPopoverOpen: false,
      filteredBenchmarkData: null,
      updatedFields: [],
      displayType: null,
      isCreateModal: false,
    };
    this.timer = null;
  }

  componentDidMount() {
    // console.log('mount edit')

    let dashboardCopy = deepClone(this.props.reports);

    this.setState({
      title: dashboardCopy.name.slice(),
      privacy: dashboardCopy.privacy.slice(),
      permission: dashboardCopy.permission.slice(),
      displayUsers: [],
      dashboardOwner: this.props.dashboardOwner,
      isUserList:
        dashboardCopy.invitedUsers && dashboardCopy.invitedUsers.length > 0
          ? true
          : false,
      invitedUsers: [...dashboardCopy.invitedUsers],
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  editTask = (field, isUndo) => {
    // console.log('field---', field)
    let { updatedFields, task_copy, task, removedFields } = this.state;

    if (updatedFields.indexOf(field) == -1) {
      updatedFields.push(field);
      this.setState({ updatedFields });
    } else {
      let res = updatedFields.filter(e => e != field);

      this.setState({ updatedFields: res });
    }
  };

  changeDashboardTitle = event => {
    const { value } = event.target;
    this.setState({ title: value });
    // this.props.changeDashboardTitle(value)
  };

  getUserList = () => {
    let { displayUsers } = this.state;
    if (displayUsers.length === 0) {
      axios
        .get(url.userListArray)
        .then(response => {
          this.setState({
            displayUsers: response.data.data.map(e => {
              if (e.firstName && e.lastName) {
                return {
                  label: `${e.firstName}, ${e.lastName}`,
                  value: e._id,
                  permissions: 0,
                };
              } else if (e.firstName || e.lastName) {
                let name =
                  e.firstName && e.firstName.length > 0
                    ? e.firstName
                    : e.lastName;
                return { label: `${name}`, value: e._id, permissions: 0 };
              } else if (!e.firstName && !e.lastName) {
                return { label: `${e.email}`, value: e._id, permissions: 0 };
              }
            }),
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  handleOptionChange = changeEvent => {
    // console.log(changeEvent.target)
    let permission = "";
    if (changeEvent === "ENTERPRISE") {
      permission = "VIEW";
      this.setState({
        privacy: changeEvent,
        permission,
        invitedUsers: [],
        isUserList: false,
      });
    } else if (changeEvent === "CUSTOM") {
      this.setState({
        isUserList: true,
        privacy: changeEvent,
      });
      // this.getUserList()
    } else {
      this.setState({
        privacy: changeEvent,
        permission: "VIEW",
        invitedUsers: [],
        isUserList: false,
      });
    }
  };

  handlePermissionChange = () => {
    let permission = this.state.permission === "EDIT" ? "VIEW" : "EDIT";

    this.setState(prevState => ({
      permission: permission,
    }));
  };

  // Toggle popover
  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
      permissionPopoverOpen: false,
    });
  };

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
      privacyPopoverOpen: false,
    });
  };

  onUserSelect = u => {
    let { invitedUsers, newUsersInvited } = this.state;

    let result;

    if (
      invitedUsers.length == 0 ||
      invitedUsers.filter(item => item.userId == u._id).length == 0
    ) {
      newUsersInvited.push(u._id);

      result = [
        {
          firstName: u.firstName,
          lastName: u.lastName,
          userId: u._id,
          orgId: u.organizationId,
          permissions: 0,
        },
        ...invitedUsers,
      ];
    } else {
      result = invitedUsers;
    }

    this.setState({ invitedUsers: result });
  };

  onUserSetPermissions = (p, u) => {
    // console.log(p, u)
    let val = `userId=${u.userId}?p=${p.value}?fullname=${
      u.firstName + "_" + u.lastName
    }`;
    let { invitedUsers, permissionsChanged } = this.state;
    if (p && p != null && p != undefined) {
      invitedUsers.forEach((item, index) => {
        if (item.userId == u.userId) {
          if (permissionsChanged.indexOf(val) == -1) {
            permissionsChanged.push(val);
          } else {
            let idx = permissionsChanged.indexOf(val);
            permissionsChanged.splice(idx, 1);
          }

          invitedUsers[index].permissions = p.value;
        }
      });
      this.setState({ invitedUsers });
    } else {
      invitedUsers.forEach((item, index) => {
        if (item.userId == u.userId) {
          if (permissionsChanged.indexOf(val) == -1) {
            permissionsChanged.push(val);
          } else {
            let idx = permissionsChanged.indexOf(val);
            permissionsChanged.splice(idx, 1);
          }

          invitedUsers[index].permissions = { label: "View", value: 0 };
        }
      });
      this.setState({ invitedUsers });
    }
  };

  renderDropDownViews = () => {
    let { privacy } = this.state;
    if (privacy) {
      return (
        <Dropdown
          isOpen={this.state.dropdownOpen}
          toggle={this.toggleTaskView}
          className="dbPrivacyDropdown"
        >
          <DropdownToggle caret>{privacyLabel[privacy]}</DropdownToggle>
          <DropdownMenu className="privacyOptionsContainer">
            {/* <DropdownItem header>Select a view</DropdownItem> */}
            <DropdownItem
              className="privacyBtnItem"
              onClick={() => this.handleOptionChange("PRIVATE")}
            >
              {privacyLabel["PRIVATE"]}
            </DropdownItem>
            <DropdownItem
              className="privacyBtnItem"
              onClick={() => this.handleOptionChange("ENTERPRISE")}
            >
              {privacyLabel["ENTERPRISE"]}
            </DropdownItem>
            <DropdownItem
              className="privacyBtnItem"
              onClick={() => this.handleOptionChange("CUSTOM")}
            >
              {privacyLabel["CUSTOM"]}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      );
    }
  };

  // enable
  privacyContent = type => {
    let { privacy, invitedUsers } = this.state;
    if (privacy) {
      if (type === "enable") {
        return (
          <div className="dbPrivacyStatusContainer">
            <span className="dbPrivacyStatusTxt">
              Privacy Status:
              {this.renderDropDownViews()}
            </span>
          </div>
        );
      } else {
        return (
          <span className="dbPrivacyStatusTxt">
            Privacy Status:{" "}
            <span className="dashboard-privacy-label">
              {privacyLabel[privacy]}
            </span>
            {invitedUsers.length > 0 ? (
              <Table responsive hover className="dbPrivacyTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Access</th>
                    {/* <th></th> */}
                  </tr>
                </thead>
                <tbody>
                  {invitedUsers.map(e => {
                    let permissionsArray = [
                      { label: "View", value: 0 },
                      { label: "Edit", value: 1 },
                    ];
                    let fullName = e.firstName + " " + e.lastName;
                    return (
                      <tr className="dbPrivacyRow" key={e.userId}>
                        <td>{fullName}</td>

                        <td>
                          {
                            permissionsArray.filter(
                              x => x.value == e.permissions
                            )[0]["label"]
                          }
                        </td>

                        {/* <td className="dbRemoveUserCol">
                            <i onClick={()=>this.removeUser(e)} className="dashboardUserIcon flaticon-trash"></i>
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : null}
          </span>
        );
      }
    }
  };

  renderPrivacyOptions = () => {
    let { user, reports } = this.props;
    let value = checkUserPrivileges(user.profile, reports, "owner")
      ? "enable"
      : 0;
    return this.privacyContent(value);
  };

  toggleTaskView = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
      // dropdownFilter: !prevState.dropdownFilter
    }));
  };

  removeUser = user => {
    // console.log('u: ', user)
    let { invitedUsers } = this.state;
    // let{invitedUsers}=currentDashboard
    invitedUsers = invitedUsers.filter(
      e => e.userId.toString() != user.userId.toString()
    );

    this.setState({ invitedUsers });
    // this.setState( prevState=>({
    //   currentDashboard:{
    //     ...prevState.currentDashboard,
    //     invitedUsers
    //   }
    // }))
  };

  assignedUserDelay = ({ target }) => {
    let { value } = target;
    this.setState({ customUser: value });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  renderPermissions = ref => {
    // let{ customUser, currentDashboard}=this.state
    let {
      customUser,
      privacy,
      newUsersInvited,
      invitedUsers,
      displayUsers,
      currentDashboard,
      isUserList,
    } = this.state;
    let { user, reports } = this.props;

    if (privacy == "ENTERPRISE") {
      return (
        <span className="permissionsContainer">
          <span className="dashboard-permission-label">Permissions:</span>

          <div className="dashboardPermissionOptions">
            <span className="dbPermissionValue">View Only</span>
            <span className="ml10">
              <Toggle
                defaultChecked={this.state.permission === "EDIT"}
                icons={false}
                onChange={this.handlePermissionChange}
              />
            </span>
            <span className="dbPermissionValue ml10">View And Edit</span>
          </div>
        </span>
      );
    } else if (privacy == "CUSTOM" && isUserList) {
      return (
        <span>
          {/* ref={c => (this.foundUsersArray = c)} */}
          <span className="dbPrivacySelect" ref={this.foundUsersArray}>
            <Input
              name="assignedUser"
              id=""
              placeholder={"Select users to share this dashboard with"}
              className="inputBox-height"
              onChange={this.assignedUserDelay}
              value={customUser}
              autoComplete={"off"}
            />
            {displayUsers &&
            displayUsers.length > 0 &&
            typeof displayUsers !== "string" ? (
              <div className="divTableSingleTask" ref={this.userTableContainer}>
                <div className="dbTableBody">
                  {displayUsers.map(user => {
                    return (
                      <div
                        className="divTableRow"
                        onClick={() => this.onUserSelect(user)}
                        key={user._id + user.organizationId}
                      >
                        <div className="dashboardTableCell">
                          {user.firstName} {user.lastName}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : typeof displayUsers === "string" ? (
              <span className="noUsersFound">{displayUsers}</span>
            ) : null}
          </span>

          {invitedUsers.length > 0 ? (
            <Table responsive hover className="dbPrivacyTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Access</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {invitedUsers.map(e => {
                  let permissionsArray = [
                    { label: "View", value: 0 },
                    { label: "Edit", value: 1 },
                  ];
                  let fullName = e.firstName + " " + e.lastName;
                  return (
                    <tr className="dbPrivacyRow" key={e.userId}>
                      <td>
                        {fullName}

                        {newUsersInvited.length > 0 &&
                        newUsersInvited.indexOf(e.userId) > -1 ? (
                          <div className="newInvitedUserLabel">Just added</div>
                        ) : null}
                      </td>

                      <td>
                        {checkUserPrivileges(user.profile, reports, "owner") ? (
                          e.userId != this.props.user.profile._id ? (
                            <Select
                              isClearable={false}
                              name="permission-select"
                              placeholder={"Select a permission/privacy"}
                              value={e.permissions}
                              isOpen={true}
                              options={
                                permissionsArray
                                // .filter(e=> e.value == e.permissions)
                                // [
                                //   {label: 'View', value:0},
                                //   {label: 'Edit', value:1},
                                // ]
                              }
                              onChange={itm =>
                                this.onUserSetPermissions(itm, e)
                              }
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          ) : (
                            permissionsArray.filter(
                              x => x.value == e.permissions
                            )[0]["label"]
                          )
                        ) : (
                          permissionsArray.filter(
                            x => x.value == e.permissions
                          )[0]["label"]
                        )}
                      </td>

                      <td className="dbRemoveUserCol">
                        <i
                          onClick={() => this.removeUser(e)}
                          className="dashboardUserIcon flaticon-trash"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : null}
        </span>
      );
    }
  };

  handleAssignUser = value => {
    // console.log('val---', value)
    let res;
    if (value && value.length > 0) {
      axios.get(url.findUser(value)).then((resp, idx) => {
        let users = resp.data.data;
        // console.log('users--', users)
        if (users.length == 0) {
          users = "No users found";
        }

        this.setState({ displayUsers: users });
      });
    } else {
      this.setState({ displayUsers: [] });
    }
  };

  privacySettingsModal = () => {
    this.setState(prevState => ({
      isPrivacy: !prevState.isPrivacy,
    }));
  };

  closeActionsModal = () => {
    this.setState(prevState => ({
      isPrivacy: false,
      isCreateModal: false,
      newUsersInvited: [],
      customUser: "",
      title: this.props.reports.name.slice(),
      privacy: this.props.reports.privacy.slice(),
      permission: this.props.reports.permission.slice(),
      displayUsers: [],
      dashboardOwner: this.props.dashboardOwner,
      isUserList:
        this.props.reports.invitedUsers &&
        this.props.reports.invitedUsers.length > 0
          ? true
          : false,
      invitedUsers: [...this.props.reports.invitedUsers],
      isPrivacy: this.props.isPrivacy,
    }));
    this.props.closeActionsModal();
  };

  changePrivacySettings = () => {
    this.setState(prevState => ({
      isPrivacy: false,
    }));
  };

  closeFilterMenu = () => {
    this.setState(prevState => ({ dropdownFilter: !prevState.dropdownFilter }));
  };

  closeUserSearch = () => {
    this.setState({ displayUsers: [] });
  };

  handleClickOutside = event => {
    if (this.foundUsersArray) {
      if (this.foundUsersArray.current) {
        let input = this.foundUsersArray.current;
        if (this.userTableContainer) {
          if (this.userTableContainer.current) {
            let ut = this.userTableContainer.current;
            if (
              input &&
              !input.contains(event.target) &&
              ut &&
              !ut.contains(event.target)
            ) {
              this.closeUserSearch();
            }
          }
        }
      }
    }
  };

  updateDashboardSettings = () => {
    this.setState({ preventCreate: false });

    let {
      permission,
      privacy,
      title,
      invitedUsers,
      newUsersInvited,
      permissionsChanged,
    } = this.state;
    let { currentDashboard, reports } = this.props;
    let modified_array = [];
    let result = {
      permission,
      privacy,
      name: title,
      invitedUsers,
      newUsersInvited,
      permissionsChanged,
    };

    let keys = Object.keys(result);

    keys.forEach((key, index) => {
      if (result[key]) {
        if (key == "invitedUsers") {
          if (
            reports[key].length != result[key].length ||
            permissionsChanged.length > 0
          ) {
            modified_array.push(key);
          }
          return modified_array;
        }
        if (reports[key] != result[key]) {
          modified_array.push(key);
        }
        return modified_array;
      }
    });

    result = { ...result, modified_array };

    let updateSettings = {
      _id: reports._id,
      dashboardAttr: {
        ...result,
      },
    };

    let that = this;
    axios
      .post(url.updateDashboard, updateSettings)
      .then(response => {
        // /dashboard/:orgId/view/:id
        this.setState({ preventCreate: false });

        let updatedDashboard = response.data.data;

        delete updatedDashboard.createdBy;

        console.log("updatedDashboard:  ", updatedDashboard);
        that.props.updateReport(updatedDashboard);
        that.setState({
          isPrivacy: false,
          isCreateModal: false,
          newUsersInvited: [],
          customUser: "",
          title: updatedDashboard.name.slice(),
          privacy: updatedDashboard.privacy.slice(),
          permission: updatedDashboard.permission.slice(),
          displayUsers: [],
          dashboardOwner: this.props.dashboardOwner,
          isUserList:
            updatedDashboard.invitedUsers &&
            updatedDashboard.invitedUsers.length > 0
              ? true
              : false,
          invitedUsers: updatedDashboard.invitedUsers,
          isPrivacy: this.props.isPrivacy,
        });
        that.props.closeActionsModal();
        // that.setState( (prevState)=> ({
        // ...updatedDashboard,
        // currentDashboard:updatedDashboard,
        // title:updatedDashboard.name,
        // shouldUpdate: !prevState.shouldUpdate
        // }))
        // that.setState((prevState)=> ({
        //   isPrivacy: false ,
        //   isCreateModal:false
        // }))
        // that.closeActionsModal()
        // let dbId = response.data.data._id
        // that.props.history.push(`/home/dashboard/${that.props.user.profile.organizationId._id}/view/${dbId}`)
      })
      .catch(error => {
        console.log(error);
      });
    //  this.setState({isPrivacy:false})
    // this.props.updateDashboardSettings(result)
  };

  createDashboardModal = () => {
    this.setState({ isCreateModal: true });
  };

  render() {
    let { dashboardOwner, preventCreate, title, isPrivacy } = this.state,
      { reports, user } = this.props;
    return (
      <Modal
        isOpen={true}
        className="dashboardModalContainer dashboardModalDetailsContainer"
      >
        <ModalHeader
          className="dashboardHeader"
          charCode="X"
          toggle={() => this.closeActionsModal()}
        >
          <div className="dashboardModalTitle">Dashboard Details</div>
        </ModalHeader>
        <ModalBody className="dashboardModalBody">
          <div className="dashboardModalBodyTxt">
            Manage dashboard settings below. Below, you can modify the dashboard
            title, owner, and access. Keep it private, share with the entire
            organization or share with specific users with distinct access
            rights.
          </div>

          <div className="dashboardOwnerTxt">Dashboard Name</div>
          <input
            type="text"
            onChange={this.changeDashboardTitle}
            value={title}
            className="dashboardDetailsTitleInput"
            maxLength={64}
          />

          <div className="dashboardOwnerTxt">Dashboard Owner</div>
          <div className="dashboardOwnerValue">{dashboardOwner}</div>

          {/* <Select
                    isMulti={true}
                    multi={true}
                    name="user-select" 
                    placeholder={"Change dashboard owner"} 
                    value={dashboardOwner} 
                    isOpen={true}
                    options={allUsers} 
                    onChange={itm =>this.changeDashboardOwner(itm)}  
                    className="basic-multi-select"
                    classNamePrefix="select"
                    /> */}

          {this.renderPrivacyOptions()}

          {checkUserPrivileges(user.profile, reports, "owner")
            ? this.renderPermissions()
            : null}

          <div
            className="submitPrivacyContainer"
            style={{ padding: "10px 0px 0px 0px" }}
          >
            <Button
              className={`profile-modal-save-btn float-left weeklyWinBtn ${
                preventCreate ? "disabledBtn" : ""
              }`}
              onClick={
                !preventCreate ? () => this.updateDashboardSettings() : null
              }
            >
              <span className="profile-modal-save-btn-txt">
                Update
                <span className="ml10 flaticon-tick"></span>
              </span>
            </Button>

            <Button
              className={`profile-modal-cancel-btn float-right weeklyWinBtn ${
                preventCreate ? "disabledBtn" : ""
              }`}
              onClick={() => this.closeActionsModal()}
            >
              <span className="profile-modal-cancel-btn-txt">Cancel</span>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(EditDboard, axios)));
